import { abis, addresses } from '@nexusmutual/sdk';
import { getContract } from 'Services/getContract';

const address = addresses.NXMToken;

const NXMToken = (provider, account) => getContract(address, abis.NXMToken, provider, account);

export default NXMToken;
